import React from "react";
import useHeroLogic from "./hooks/useHeroLogic";
import HeroDesktop from "./components/HeroDesktop";
import HeroMobile from "./components/HeroMobile";

function Hero() {
  const { screenSize } = useHeroLogic();

  return screenSize === "mobile" ? <HeroMobile /> : <HeroDesktop />;
}

export default Hero;
